import React, { useState, useEffect } from 'react';
import { Copy, X } from 'lucide-react';
import './SharePopup.css';
import AdSenseUnit from './AdSenseUnit';

const SharePopup = ({ link, phrase, onClose }) => {
  const [timeLeft, setTimeLeft] = useState(900);

  useEffect(() => {
    if (timeLeft <= 0) {
      window.location.reload();
      return;
    }
    const timer = setInterval(() => setTimeLeft(prev => prev - 1), 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert('Copied to clipboard!');
  };

  return (
    <div className="popup-overlay">
      <div className="share-card">
        <div className="share-header">
          <h2>Share link</h2>
          <button className="close-btn" onClick={onClose}><X size={20} /></button>
        </div>

        <p className="share-desc">
          here is your phrase information, please share it with your guest.
        </p>

        <div className="input-group">
          <div className="label-box">Link</div>
          <div className="value-box">{link}</div>
          <button className="copy-btn" onClick={() => copyToClipboard(link)}>
            <Copy size={18} color="white" />
          </button>
        </div>

        <div className="input-group">
          <div className="label-box">Phrase</div>
          <div className="value-box truncate">{phrase}</div>
          <button className="copy-btn" onClick={() => copyToClipboard(phrase)}>
            <Copy size={18} color="white" />
          </button>
        </div>

        <div className="share-buttons">
          <a 
            href={`https://wa.me/?text=${encodeURIComponent(`Join my private chat on MeetingPoint:\n\nLink: ${link}\nPhrase: ${phrase}`)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="share-btn whatsapp"
          >
            <i className="fab fa-whatsapp"></i>
            <span>WhatsApp</span>
          </a>
          <a 
            href={`mailto:?subject=${encodeURIComponent('Join my MeetingPoint chat')}&body=${encodeURIComponent(`I'd like to invite you to a private chat on MeetingPoint.\n\nClick this link: ${link}\n\nOr enter this phrase: ${phrase}\n\nNo account needed - just click and join!`)}`}
            className="share-btn email"
          >
            <i className="fas fa-envelope"></i>
            <span>Email</span>
          </a>
        </div>

        <div className="share-footer">
          <span>Time left before phrase expiry (Waiting on Guest)</span>
          <span className="timer">{formatTime(timeLeft)}</span>
        </div>

        <AdSenseUnit adSlot="7483116228" adFormat="auto" />

      </div>
    </div>
  );
};

export default SharePopup;
